export enum PAYMENT_SESSION_STATUS {
  PAYMENT_PENDING = 'payment_pending',
  PAYMENT_SUCCESS = 'payment_success',
  PAYMENT_FAILED = 'payment_failed',
  REFUND_SUCCESS = 'refund_success',
  REFUND_FAILED = 'refund_failed',
}
